module.exports = __webpack_public_path__ + "img/img-5.1406ca69.png";